<div class="pt-3" [innerHTML]="data.text"></div>
<div class="dialog-footer">
    <div class="d-flex flex-row w-100">
        <ng-container *ngFor="let btn of data.btns">
            <div [class]="btn.divClasses">
                <button type="button" [class]="btn.btnClasses" (click)="close(btn.type)">
                    <div [innerHTML]="btn.text"></div>
                </button>
            </div>
        </ng-container>
    </div>
</div>
